import { createSelector } from '@ngrx/store';
import { AppState } from '../appState';

const firmState = (state: AppState) => state.firm;

const selectFirm = createSelector(firmState, (state) => state.firm);
const selectFirmId = createSelector(selectFirm, (state) => state?.id ?? null);
const selectHasActiveAmlConnection = createSelector(firmState, (state) => !!state.amlApiEmail);
const selectAmlApiEmail = createSelector(firmState, (state) => state.amlApiEmail);
const selectFirmSettings = createSelector(firmState, (state) => state.settings);
const selectFirmProperties = createSelector(firmState, (state) => state.firm?.properties);
const selectFirmCustomerNbr = createSelector(firmState, (state) => +(state.firm?.blueBLACustomerNumber ?? ''));

const selectCountryCode = createSelector(selectFirm, (state) => state?.countryCode ?? 'SE');

export const FirmSelectors = {
  selectFirm,
  selectFirmId,
  selectHasActiveAmlConnection,
  selectAmlApiEmail,
  selectFirmSettings,
  selectCountryCode,
  selectFirmProperties,
  selectFirmCustomerNbr,
};
